module.exports = __webpack_public_path__ + "static/img/buddy_mini_pictgrid12_800x800.d23a512.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_mini_pictgrid12_800x800.jpg
// module id = xv39
// module chunks = 0